import * as Circuit from './routes/circuit';
import * as Customer from './routes/customer';
import * as CustomerDeviceAssignment from './routes/customer-device-assignment';
import * as CustomerInvoiceRoutes from './routes/customer-invoice';
import * as CustomerOrderRoutes from './routes/customer-order';
import * as CustomerOrderAttachmentRoutes from './routes/customer-order-attachment';
import * as CustomerOrderItemRoutes from './routes/customer-order-item';
import * as DeviceInventoryRoutes from './routes/device-inventory-log';
import * as PriceSetItemTypeRoutes from './routes/price-set-item-type';
import * as DeviceAssignmentRoutes from './routes/device-assignment';
import * as DeviceContractRoutes from './routes/device-contract';
import * as DeviceContractLedgerRoutes from './routes/device-contract-ledger';
import * as DeviceRoutes from './routes/device';
import * as GatewayRoutes from './routes/gateway';
import * as OrganisationRoutes from './routes/organisation';
import * as OverviewRoutes from './routes/overview';
import * as UserOrganisationRoutes from './routes/user-organisation';
import * as UserRoutes from './routes/user';
import * as PriceSetRoutes from './routes/price-set';
import * as PriceSetItemRoutes from './routes/price-set-item';
import * as PropertyRoutes from './routes/property';
import * as LegacyRoutes from './routes/legacy-routes';
import * as StockaRoutes from './routes/stocka';
import * as XeroRoutes from './routes/xero';
import * as SSOProviderRoutes from './routes/sso-provider';
import * as OAuthClientRoutes from './routes/oauth-client';
import * as BulkDeviceProvisionRoutes from './routes/bulk-device-provision';
import * as AlarmHistoryRoutes from './routes/alarm-history';
import * as MfaRoutes from './routes/mfa';

const TetherApi = {
  ...LegacyRoutes,
  ...Circuit,
  ...Customer,
  ...CustomerDeviceAssignment,
  ...CustomerInvoiceRoutes,
  ...CustomerOrderRoutes,
  ...CustomerOrderAttachmentRoutes,
  ...CustomerOrderItemRoutes,
  ...DeviceInventoryRoutes,
  ...PriceSetItemTypeRoutes,
  ...DeviceAssignmentRoutes,
  ...DeviceContractRoutes,
  ...DeviceContractLedgerRoutes,
  ...DeviceRoutes,
  ...GatewayRoutes,
  ...OrganisationRoutes,
  ...OverviewRoutes,
  ...UserOrganisationRoutes,
  ...UserRoutes,
  ...PriceSetRoutes,
  ...PriceSetItemRoutes,
  ...PropertyRoutes,
  ...StockaRoutes,
  ...XeroRoutes,
  ...SSOProviderRoutes,
  ...OAuthClientRoutes,
  ...BulkDeviceProvisionRoutes,
  ...AlarmHistoryRoutes,
  ...MfaRoutes,
};

export default TetherApi;
